import { AlertCircle } from 'lucide-react'
import { useEffect, useState } from 'react'
import { DateRange } from 'react-day-picker'

import { Card, CardContent, CardTitle } from '@/components/ui/card'

interface DateRangeValidatorProps {
  dateRange: DateRange | undefined
  children: React.ReactNode
  placeholder?: React.ReactNode
  chartType?: string
  chartTitle?: string
}

export const DateRangeValidator = ({
  dateRange,
  children,
  chartType = 'chart',
  chartTitle,
  placeholder,
}: DateRangeValidatorProps) => {
  const [isValid, setIsValid] = useState(false)

  const defaultPlaceholder = (
    <Card className="w-full p-4">
      <CardTitle>{chartTitle}</CardTitle>
      <CardContent className="flex flex-col items-center justify-center gap-4 py-8 text-center">
        <div className="flex items-center gap-2 text-muted-foreground">
          <AlertCircle className="h-5 w-5" />
          <p className="text-sm whitespace-normal">
            Select a date range longer than one month to view {chartType}
          </p>
        </div>
      </CardContent>
    </Card>
  )

  const isDateRangeValid = () => {
    if (!dateRange?.from || !dateRange?.to) {
      return false
    }

    const diffTime = Math.abs(dateRange.to.getTime() - dateRange.from.getTime())
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

    return diffDays > 30
  }

  useEffect(() => {
    if (isDateRangeValid()) {
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  }, [dateRange])

  return isValid ? <>{children}</> : placeholder || defaultPlaceholder
}
